import React from "react";
import "./ZenProductSection.css";
import { FiCheckCircle } from "react-icons/fi";

// Images
import mainImage from "../../assets/images/zen/pulso-main-image.png";
import crossSection from "../../assets/images/zen/1-light-edited.jpg";
import labelsection from "../../assets/images/zen/labelled.png";
import color1 from "../../assets/images/zen/Crimson Snow.png";
import color2 from "../../assets/images/zen/Blue Slate.png";
import color3 from "../../assets/images/zen/Ocean Blue.png";
import color4 from "../../assets/images/zen/Sunrise Yellow.png";
import dimensionSectionone from "../../assets/images/zen/one-hundred-nine-hundred-two-dimension.png";
import dimensionSectiontwo from "../../assets/images/zen/one-hundred-nine-sixhundred-two-dimension.png";
import dimensionSectionthree from "../../assets/images/zen/one-hundred-sixty-two-dimension.png";
import dimensionSectionfour from "../../assets/images/zen/fifty-four-dimension.png";
import featureone from "../../assets/images/zen/second-section-main-label.png";
import featuretwo from "../../assets/images/zen/crafted-parting.png";
import featurethree from "../../assets/images/zen/Dual-mass.png";
import featurefour from "../../assets/images/zen/transparency-imbues.png";
import zensmallheightbanner from "../../assets/images/zen/small-height-banner.png";

// Reusable Components
const SectionTitle = ({ title }) => (
  <h2 className="zen-section-title">{title}</h2>
);

const ImageWithCaption = ({ src, alt, caption }) => (
  <div className="zen-image-block">
    <img src={src} alt={alt} />
    {caption && <p className="zen-caption">{caption}</p>}
  </div>
);

const ZenProductSection = () => {
  const highlights = [
    "The PulsOjet® Disposable Pulse Lavage System is an advanced battery-powered",
    "irrigation system designed for wound debridement and orthopedic surgeries.",
    "It ensures effective wound cleansing, infection control, and enhanced surgical outcomes with high-pressure pulsatile irrigation",
  ];

  const productHighlights = [
    "Compact and ergonomic design",
    "Transparent detailing for visual assurance",
    "Designed with usability at the core",
  ];

  const features = [
    {
      src: featureone,
      text: "Lightweight & Ergonomic – Designed for precision & surgeon comfort",
    },
    {
      src: featurefour,
      text: "Built-in Battery – No external power needed, fully self-contained system",
    },
    {
      src: featuretwo,
      text: "Optimized Fluid Delivery – Ensures effective tissue hydration and cleaning",
    },
    {
      src: featurethree,
      text: "Variable speed settings with toggle power – Adjustable high/low flow rates for precise irrigation\nIntuitive toggle switch for effortless on/off operation",
    },
  ];

  const dimensions = [
    dimensionSectionthree,
    dimensionSectionfour,
    dimensionSectionone,
    dimensionSectiontwo,
  ];

  const colors = [
    { src: color1, name: "Crimson Snow" },
    { src: color2, name: "Blue Slate" },
    { src: color3, name: "Ocean Blue" },
    { src: color4, name: "Sunrise Yellow" },
  ];

  return (
    <section className="zen-section">
      <div className="zen-container">
        <div className="zen-divider" />

        <div className="zen-text">
          <h2 className="zen-title">
            Meet PulsOjet® – A New Generation of Pulse Lavage System
          </h2>
          <p className="zen-highlights">{highlights.join(" ")}</p>
        </div>

        <div className="zen-image-grid">
          <div className="zen-image-main">
            <ImageWithCaption src={mainImage} alt="Zen Main Product" />
          </div>
          <div className="zen-text-highlights">
            <h3 className="zen-title">Product Highlights</h3>
            <ul className="zen-bullet-points">
              {productHighlights.map((point, i) => (
                <li key={i}>
                  <FiCheckCircle /> {point}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="zen-divider" />
        <div className="smallest-banner">
          <div
            className="banner-wrpper-small-height"
            style={{ backgroundImage: `url(${zensmallheightbanner})` }}
          >
            <div className="cross-container-left">
              {dimensions.map((img, i) => (
                <div className="zen-image-block-first" key={i}>
                  <img src={img} alt="Cross Section" />
                </div>
              ))}
            </div>
          </div>
        </div>

        <SectionTitle title="Engineering with Elegance" />
        <div className="zen-design-highlight-all">
          {features.map((f, i) => {
            const [heading, ...contentParts] = f.text.split("–");
            const contentLines = contentParts.join("–").split("\n");

            return (
              <div className="zen-feature-box" key={i}>
                <img src={f.src} alt="Feature" />
                <p>
                  <strong>{heading.trim()}</strong>
                  {contentLines.map((line, idx) => (
                    <span key={idx}>{line.trim()}</span>
                  ))}
                </p>
              </div>
            );
          })}
        </div>

        <div className="zen-divider" />
        <SectionTitle title="Engineered Inside Out" />

        <div className="cross-section-wrapper">
          <div className="three-some-wrapper">
            <div className="eye-catching-text-box left-side-cross">
              <ul className="cross-section-points">
                <div className="left-alignment-box">
                  <li className="box-five">
                    <p className="mobile-indicator">
                      <span className="red-indicator">
                        ← Refers to left-side top arrow
                      </span>
                    </p>
                    <strong>Sterile Flow Alignment</strong>
                    <p>Fluid channels are separated and streamlined</p>
                    <p>for safe delivery and quick decontamination.</p>
                  </li>
                  <li className="box-four">
                    <p className="mobile-indicator">
                      <span className="red-indicator">
                        ← Points to left-side bottom arrow
                      </span>
                    </p>
                    <strong>Monocoque Body Design</strong>
                    <p>
                      Enhances structural integrity while reducing part
                      complexity.
                    </p>
                  </li>
                </div>
              </ul>
            </div>

            <div className="cross-container-right">
              <div className="zen-image-block-first">
                <img src={crossSection} alt="Cross Section" />
              </div>
            </div>

            <div className="eye-catching-text-box right-side-cross">
              <ul className="cross-section-points">
                <div className="right-alignment-box">
                  <li className="box-two">
                    <p className="mobile-indicator">
                      <span className="red-indicator">
                        → Linked to right-side top arrow
                      </span>
                    </p>
                    <strong>Rear Battery Pack</strong>
                    <p>
                      Positioned for weight balance and quick plug-and-use
                      operation.
                    </p>
                  </li>
                  <li className="box-one">
                    <p className="mobile-indicator">
                      <span className="red-indicator">
                        → Points to right-side middle arrow
                      </span>
                    </p>
                    <strong>Compact Motor Housing</strong>
                    <p>
                      Integrates securely within the body for minimal noise and
                      efficient power delivery.
                    </p>
                  </li>
                  <li className="box-three">
                    <p className="mobile-indicator">
                      <span className="red-indicator">
                        → Refers to right-side bottom arrow
                      </span>
                    </p>
                    <strong>Direct Pipe Pathway</strong>
                    <p>
                      Transparent routing minimizes bends optimizing flow,
                      suction, and flushing efficiency.
                    </p>
                  </li>
                </div>
              </ul>
            </div>
          </div>
          <p className="cross-section-summary">
            From motor mount to tubing route, every component of PulsOjet's®
            interior is designed to minimize noise, weight, and fluid resistance
            — ensuring performance that matches surgeon precision.
          </p>
        </div>

        <div className="zen-divider" />
        <div className="lable-components-wrap">
          <SectionTitle title="Component Breakdown (Interactive)" />
          <ImageWithCaption src={labelsection} alt="Labelled Section" />
        </div>

        <div className="zen-divider" />
        <SectionTitle title="Color Options" />
        <div className="zen-colors-row">
          {colors.map((clr, i) => (
            <div className="colrs-img-bx" key={i}>
              <img src={clr.src} alt={clr.name} />
              <p className="zen-caption">{clr.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ZenProductSection;
